import { render, staticRenderFns } from "./CollegeNameWithLogo.vue?vue&type=template&id=16d7f36e&"
import script from "./CollegeNameWithLogo.vue?vue&type=script&lang=ts&"
export * from "./CollegeNameWithLogo.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports